// "Spot the Slip" expansion — FAMILY theme. Shape:
//   [ wrong, right, tag, why, slug ]

export const CORRECTIONS_FAMILY = [
  ["Mi padre es jubilado y muy feliz.", "Mi padre está jubilado y muy feliz.", "ser-estar",
    "Estar jubilado describes a current life-state → estar.", "ser-vs-estar"],
  ["Mis padres son divorciados desde 2019.", "Mis padres están divorciados desde 2019.", "ser-estar",
    "A resulting marital state uses estar → están divorciados.", "ser-vs-estar"],
  ["La boda es en la iglesia del pueblo.", "La boda es en la iglesia del pueblo.", "ser-estar",
    "Trap check: an event 'taking place' correctly uses ser. (Already correct!)", "ser-vs-estar"],
  ["Mi suegra es muy amable, está una buena cocinera.", "Mi suegra es muy amable y es una buena cocinera.", "ser-estar",
    "A defining role (being a good cook) is identity → ser.", "ser-vs-estar"],
  ["Tengo un sobrina muy lista.", "Tengo una sobrina muy lista.", "gender",
    "Sobrina is feminine; use una.", "gender-agreement-of-nouns"],
  ["Mi prima es alto y delgado.", "Mi prima es alta y delgada.", "gender",
    "Feminine subject → alta y delgada.", "adjective-agreement"],
  ["Los padres de María son muy unido.", "Los padres de María están muy unidos.", "gender",
    "Plural agreement plus the close-knit state → están muy unidos.", "adjective-agreement"],
  ["Me gusta mis primos de Chile.", "Me gustan mis primos de Chile.", "gustar",
    "The verb agrees with the thing liked; plural cousins → gustan.", "gustar-and-similar-verbs"],
  ["A mis hermanos les gusta los domingos en familia.", "A mis hermanos les gustan los domingos en familia.", "gustar",
    "Plural Sundays → gustan.", "gustar-and-similar-verbs"],
  ["Compré un regalo por mi madrina.", "Compré un regalo para mi madrina.", "por-para",
    "A recipient of a gift takes para.", "por-vs-para"],
  ["Gracias para acoger a mi sobrino.", "Gracias por acoger a mi sobrino.", "por-para",
    "Cause or motive ('thanks because of') takes por.", "por-vs-para"],
  ["Cuando éramos niños, fuimos a casa de la abuela cada verano.", "Cuando éramos niños, íbamos a casa de la abuela cada verano.", "preterito-imperfecto",
    "A repeated childhood habit is imperfecto → íbamos.", "a2-preterito-vs-imperfecto"],
  ["El bebe de mi prima nació en marzo.", "El bebé de mi prima nació en marzo.", "accents",
    "Bebé is aguda ending in a vowel, so it needs the accent.", "stress-and-written-accents"],
  ["Espero que mi familia viene a la boda.", "Espero que mi familia venga a la boda.", "subjunctive",
    "Esperar que (hope) flips the verb to the subjunctive → venga.", "b1-present-subjunctive"],
  ["Quiero que mis hijos se llevan bien.", "Quiero que mis hijos se lleven bien.", "subjunctive",
    "A wish about others (querer que) triggers the subjunctive → se lleven.", "b1-present-subjunctive"],
];
